import z from 'zod';

export const orgsWithEnabledConnectionsForUser = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    enabledConnections: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        strategy: z.string(),
      }),
    ),
  }),
);

export const enabledConnectionSchema = z.object({
  name: z.string(),
  strategy: z.string(),
});

export const authDecisionTokenSchema = z.discriminatedUnion('mode', [
  z.object({
    mode: z.literal('defer-org'),
    organization: z.string(),
    connection: z.string(),
    email: z.string(),
  }),
  // grant-org drives an org-scoped login. With `connection` set the frontend redirects
  // straight to that connection (post-login grant flow, and non-SSO orgs that allow
  // password). Without it, the org disallows the user's chosen method, so
  // `enabledConnections` lists the remaining methods for a picker.
  z.object({
    mode: z.literal('grant-org'),
    organization: z.string(),
    connection: z.string().optional(),
    email: z.string(),
    enabledConnections: z.array(enabledConnectionSchema).optional(),
  }),
]);

export type AuthDecisionTokenPayload = z.infer<typeof authDecisionTokenSchema>;

export const TARGET_ORG_PARAM = 'target_organization';

export type DeferredOrgParam = { [TARGET_ORG_PARAM]?: string };
